"use client";

import * as React from "react";

// Drifting matrix-style green dots scattered across the viewport.
// Pure CSS; positions seeded once on mount so they don't jitter on re-render.
export function SparkleBackground() {
  const [dots] = React.useState(() => {
    const list: { left: number; top: number; size: number; delay: number; dur: number }[] = [];
    for (let i = 0; i < 40; i++) {
      list.push({
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 1 + Math.random() * 2,
        delay: Math.random() * 6,
        dur: 4 + Math.random() * 6,
      });
    }
    return list;
  });
  return (
    <div aria-hidden className="sparkle-wrap">
      {dots.map((d, i) => (
        <span
          key={i}
          className="sparkle"
          style={{
            left: `${d.left}%`,
            top: `${d.top}%`,
            width: `${d.size}px`,
            height: `${d.size}px`,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.dur}s`,
          }}
        />
      ))}
      <style>{`
        .sparkle-wrap {
          position: fixed; inset: 0; pointer-events: none; z-index: 0;
          overflow: hidden;
        }
        .sparkle {
          position: absolute;
          background: var(--jobu-sparkle);
          border-radius: 50%;
          opacity: 0;
          box-shadow: 0 0 6px 1px var(--jobu-sparkle-glow);
          animation: sparkle-twinkle linear infinite;
        }
        @keyframes sparkle-twinkle {
          0%, 100% { opacity: 0; transform: scale(0.6); }
          25%      { opacity: 0.55; transform: scale(1.1); }
          50%      { opacity: 0.2; transform: scale(0.85); }
          75%      { opacity: 0.7; transform: scale(1.15); }
        }
      `}</style>
    </div>
  );
}
